import React, { ChangeEvent, useCallback } from 'react';
import { CustomFormItem } from '../../custom-form-item';
import { Input } from 'antd/';
import { MetadataFormFieldProps } from '../types';


export const UrlField: React.FC<MetadataFormFieldProps> = (props) => {
  const {
          validationStatus,
          value,
          label,
          disabled,
          onChange,
          required
        } = props;

  const internalOnChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) =>
      onChange(e.target.value),
    [onChange],
  );

  return (
    <CustomFormItem
      label={label}
      validateStatus={validationStatus}
      required={required}
    >
      <Input
        type="url"
        disabled={disabled}
        value={value}
        onChange={internalOnChange}
        allowClear
      />
    </CustomFormItem>
  );
};
